import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { destroy } from 'redux-form';

import { getCompaniesBySearchStr } from 'actions/Companies/filterCompanies';
import { getCompaniesContact } from 'actions/Locations/getCompaniesContact';
import { getCompanyLocations } from 'actions/Locations/getCompanyLocations';
import { getAssignedLotsForOutgoingShipment } from 'actions/Lots/getAssignedLots';
import {
  clearAllPackagesOverview,
  clearPackagesOverview,
  getPackagesUnsentForShipments,
} from 'actions/Packages/packagesOverviewList';
import { createIncomingShipment } from 'actions/Shipments/createShipment';
import {
  clearShipmentPackagesList,
  shipmentPackagesList,
} from 'actions/Shipments/shipmentPackagesList';
import { openModal, closeModal } from 'actions/shared/modal';
import { showSnackbar } from 'actions/shared/snackbar';

import { CreateIncomingShipment } from './CreateIncomingShipment';

const mapStateToProps = state => ({
  auth: state.auth,
  modal: state.modal,
  companyLocations: state.companyLocations,
  packagesOverviewList: state.packagesOverviewList,
  shipmentPackagesListData: state.shipmentPackagesListData,
  isPending: state.createShipment.isPending,
});

const mapDispatchToProps = {
  clearPackagesOverview,
  clearShipmentPackagesList,
  closeModal,
  createIncomingShipment,
  getAssignedLotsForOutgoingShipment,
  getCompaniesBySearchStr,
  getCompanyLocations,
  getPackagesUnsentForShipments,
  openModal,
  shipmentPackagesList,
  showSnackbar,
  clearAllPackagesOverview,
  getCompaniesContact,
  destroy,
};

const ConnectedCreateIncomingShipment = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(CreateIncomingShipment),
);

export { ConnectedCreateIncomingShipment };
